import { CreateEntityBtn } from '@app/components/EntityActions';
import { NullState } from '@mi-front/ui';
import { FormattedMessage } from 'react-intl';

export function NoUsers() {
  return (
    <NullState>
      <div className="mb-4">
        <FormattedMessage
          id="admin.groups.listScreen.noGroups"
          defaultMessage="No se encontraron grupos"
        />
      </div>
      <CreateEntityBtn size="sm" className="ml-3" type="info" entity="user" />
    </NullState>
  );
}
